/**
 * Created by Diana Aglyamutdinova 22.04.2019
 */

/**
 * @class start view of program container Layer
 * @extends pmui.NodeLayer
 * @constructor
 * @param {Number} [hideDuration=pmui.PopupLayer.STANDARD_HIDE_DURATION] Delay before self removing.
 */

pmui.BoolNode = pmui.NodeLayer.extend(/** @lends pmui.NodeLayer# */{
	//_number: null,
	_value: 1,
	text: null,

	ctor: function (treeNode, parent)
	{
		this._withRoundBorder = true;
		this._super(parent, treeNode);
		this.setLayoutType(ccui.Layout.RELATIVE);
		//this._number =  new ccui.ImageView(pm.spriteUtils.getBoolSpriteName( pm.NORMAL_STATE),
		//ccui.Widget.PLIST_TEXTURE);
		var align = new ccui.RelativeLayoutParameter();
		align.setAlign(ccui.RelativeLayoutParameter.CENTER_IN_PARENT);
		align.setMargin(15, 5, 15, 5);
		if(pmui.NodeLayer.KUMIR_MODE)
		{
			align.setMargin(5, 10, 5, 0);
		}
		this.text = this.createText(pm.BoolTrue, pmui.NodeLayer.CONST_COLOR, 18);

		this.addChild(this.text);
		//this.createALignSome(this._number, "", "",ccui.RelativeLayoutParameter.CENTER_IN_PARENT);
		this.text.setLayoutParameter(align);
		this._repTypes = [FunctionButton.Type.Variable, FunctionButton.Type.Condition, FunctionButton.Type.LogicExpression];
		//this.calculateSize(true);
	},

	// select: function()
	// {
	// 	this._number.loadTexture(pm.spriteUtils.getBoolSpriteName( pm.SELECTED_STATE),
	// 		ccui.Widget.PLIST_TEXTURE);
	// },
	//
	// deSelect: function()
	// {
	// 	this._number.loadTexture(pm.spriteUtils.getBoolSpriteName( pm.NORMAL_STATE),
	// 		ccui.Widget.PLIST_TEXTURE);
	// },
	select: function ()
	{
		if(pmui.NodeLayer.KUMIR_MODE)
			return;
		if (!this._selected)
		{
			this.setBackGroundImage("PiktomirK/select-romb-border.png");
			this.setBackGroundImageCapInsets(cc.rect(28, 22, 70, 6));
			this._selected = true;
			this.setTag(ProgramContainerLayer.SELECTED_TAG);
		}
	},

	highlight: function ()
	{
		if(pmui.NodeLayer.KUMIR_MODE)
			return;
		this.setBackGroundImage("PiktomirK/select-romb-border.png");
		this.setBackGroundImageCapInsets(cc.rect(28, 22, 70, 6));
	},

	drawBackground: function ()
	{
		if(pmui.NodeLayer.KUMIR_MODE)
			return;
		if (!this.isEditable())
			this.setBackGroundImage("PiktomirK/romb-blocked.png");
		else
			this.setBackGroundImage("PiktomirK/romb-border.png");
		this.setBackGroundImageScale9Enabled(true);
		this.setCascadeOpacityEnabled(false);
		this.setBackGroundImageCapInsets(cc.rect(28, 22, 70, 6));
	},

	clickCallback: function ()
	{
		if(this._value === 1)
		{
			this._value = 0;
			this._treeNode.value = 0;
			this.text.setString(LocalizedString(pm.BoolFalse));
		}
		else
		{
			this._value = 1;
			this._treeNode.value = 1;
			this.text.setString(LocalizedString(pm.BoolTrue));
		}
	},

	calculateSize: function (forParent)
	{
		if(pmui.NodeLayer.KUMIR_MODE)
			this.setContentSize(this.text.getContentSize());
		else
			this.sizeOfContainer(this);

		if(!forParent)
			this._parentNode.calculateSize();
	}
});


